import { ReactNode } from 'react'

import styles from './releaseNotes.styl'

export const Badge = ({ content }: { content: string | ReactNode }): JSX.Element | null => (
  <div className={styles.badge}>{content}</div>
)
